const ItemGenerator = require('../../../game_items/ItemGenerator');
const LightTorsoe = require('../../../game_items/equipment/torsoe/LightTorsoe');
const LightBoots = require('../../../game_items/equipment/boots/LightBoots');
const Staff = require('../../../game_items/equipment/weapon/Staff');
const getMobEquipmenAssignmentFromBags = require('../mobs/getMobEquipmenAssignmentFromBags');

const Faerie = (level, summoner) => {
  const handle = 'faerie';
  const types = ['flying', 'healer', 'magic', 'summoned'];
  const bags = [
    {
      items: [
        ItemGenerator.getRandomItem(LightTorsoe, level / 10, level / 5),
        ItemGenerator.getRandomItem(LightBoots, level / 10, level / 5),
        ItemGenerator.getRandomItem(Staff, level / 10, level / 5),
      ].map((item) => ({ value: item })),
    },
  ];
  const ai_priorities = ['support', 'interference', 'dps_close', 'tank', 'dps_ranged'];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'faerie_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          mystic_focus: { handle: 'mystic_focus', level: bound_level * 2 },
          healing_prayer: { handle: 'healing_prayer', level: bound_level * 2 },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => {
      const { base, fromUpgrades, fromEquipment, fromConditions } = summoner.attributes;
      const summoner_learning =
        base.learning + fromUpgrades.learning + fromEquipment.learning + fromConditions.learning;
      return {
        learning: Math.round(3 + bound_level * 1.5 + summoner_learning * 0.3 + Math.random() * 2.1),
        perception: Math.round(
          4 + bound_level * 1.0 + summoner_learning * 0.2 + Math.random() * 2.1
        ),
        mana: Math.round(6 + bound_level * 2.5 + summoner_learning * 0.5 + Math.random() * 2.1),
        toughness: Math.round(
          2 + bound_level * 1.5 + summoner_learning * 0.3 + Math.random() * 2.1
        ),
        strength: Math.round(1 + bound_level * 0.5 + summoner_learning * 0.1 + Math.random() * 2.1),
        willpower: Math.round(
          8 + bound_level * 3.0 + summoner_learning * 0.6 + Math.random() * 2.1
        ),
        dexterity: Math.round(
          5 + bound_level * 2.0 + summoner_learning * 0.4 + Math.random() * 2.1
        ),
      };
    }).bind(null, level),
    getDefaultAIConfig: () => ai_priorities,
    getStarterEquipment: () => {},
    bags,
    build: {
      ai: {
        priorities: ai_priorities,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [
        { value: 'move' },
        { value: 'melee_attack' },
        { value: 'mystic_focus' },
        { value: 'healing_prayer' },
      ],
      handle,
      level,
      team: summoner.team,
      types,
      unit: true,
    },
  };
};
module.exports = Faerie;
